/* eslint-disable @typescript-eslint/no-unused-expressions */
import { BookingsType } from '@@types/data/bookings';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  list_booking: {
    bookings: [] as BookingsType,
  } as any,
  detail: {} as any,
  create_booking: {},
};

const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {
    requestBookings: (_state, _action: PayloadAction<{ page?: number; limit?: number }>) => {},

    saveBookings: (state, action: PayloadAction<{ list: any; limit?: number }>) => {
      const { list, limit } = action.payload;
      state.list_booking = {
        ...list,
        limit,
      };
    },
    requestBookingDetail: (state, action: PayloadAction<{ id: any }>) => {
      state;
      action;
    },
    saveBookingDetail: (state, action: PayloadAction<{ data: any }>) => {
      state.detail = action.payload.data;
    },

    requestCreateBooking: (_state, _action: PayloadAction) => undefined,
    saveCreacteBooking: (_state, _action: PayloadAction<{ data: any }>) => {
      _state.create_booking = _action.payload.data;
    },
    resetBooking: () => initialState,
  },
});

export const bookingActions = bookingSlice.actions;
export default bookingSlice;
